import { graphql } from "@opensea/graphql"
import { CollectionCategoryChipFragment } from "./chips/CollectionCategoryChip"
import { CollectionChainChipFragment } from "./chips/CollectionChainChip"
import { CollectionCreatedAtChipFragment } from "./chips/CollectionCreatedAtChip"
import { CollectionDropStatusChipFragment } from "./chips/CollectionDropStatusChip"
import { CollectionFloorPriceChipFragment } from "./chips/CollectionFloorPriceChip"
import { CollectionItemCountChipFragment } from "./chips/CollectionItemCountChip"
import { CollectionOwnerChipFragment } from "./chips/CollectionOwnerChip"

export const CollectionMetadataChipFragment = graphql(
  `
    fragment CollectionMetadataChip on Collection {
      ...CollectionOwnerChip
      ...CollectionChainChip
      ...CollectionCategoryChip
      ...CollectionCreatedAtChip
      ...CollectionItemCountChip
      ...CollectionFloorPriceChip
      ...CollectionDropStatusChip
    }
  `,
  [
    CollectionOwnerChipFragment,
    CollectionChainChipFragment,
    CollectionCategoryChipFragment,
    CollectionCreatedAtChipFragment,
    CollectionItemCountChipFragment,
    CollectionFloorPriceChipFragment,
    CollectionDropStatusChipFragment,
  ],
)
